import { Injectable } from '@angular/core';

export interface BuildInfo {
  buildDate: string;
  gitHash: string;
  gitBranch: string;
  timestamp: number;
}

@Injectable({
  providedIn: 'root'
})
export class BuildInfoService {
  private buildInfo: BuildInfo | null = null;

  constructor() {
    this.loadBuildInfo();
  }

  private async loadBuildInfo(): Promise<void> {
    try {
      const response = await fetch('/assets/build-info.json');
      if (response.ok) {
        this.buildInfo = await response.json();
      } else {
        console.warn('Could not load build info');
      }
    } catch (error) {
      console.warn('Error loading build info:', error);
    }
  }

  getBuildInfo(): BuildInfo | null {
    return this.buildInfo;
  }

  getFormattedBuildDate(): string {
    if (!this.buildInfo) return 'unknown';

    if (this.buildInfo.buildDate == 'today') {
      const today = new Date();
      return today.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    }

    const date = new Date(this.buildInfo.buildDate);
    if (!(date instanceof Date) || isNaN(date.valueOf())) {
      return 'invalid date';
    }

    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }


  getShortHash(): string {
    return this.buildInfo?.gitHash || 'unknown';
  }
}
